import { extend } from 'flarum/extend';
import app from 'flarum/app';
import DiscussionList from 'flarum/components/DiscussionList';
import DiscussionListItem from 'flarum/components/DiscussionListItem';
import { truncate } from 'flarum/utils/string';

export default function ShowLastPost() {


    extend(DiscussionList.prototype, 'requestParams', function(params) {
        params.include.push('lastPost');
    });

    extend(DiscussionListItem.prototype, 'infoItems', function(items) {

        const discussion = this.props.discussion;

        const lastPost = discussion.lastPost();
        const lastpostLength = app.forum.attribute('flarumalshain-showlastpost.excerpt_length') || 200;

        if (lastPost) {

            const showlastpost = m.trust(truncate(lastPost.contentHtml(),lastpostLength));

            items.add('lastpost', showlastpost, -100);
        }
    });
}

